export type ThemeVariants = 'light' | 'dark';
export type BannerVariants = 'info' | 'success' | 'critical';
export type SizeVariants = 'small' | 'medium' | 'large';
export type Breakpoints = 'mobile' | 'tablet' | 'desktop' | 'large' | 'all';
export type ColorVariants = 'neutral' | 'primary' | 'secondary' | 'success' | 'critical';
export type ButtonVariants = ColorVariants | 'text';
export type ChipVariants = ColorVariants;
